import {defineStore} from "pinia/dist/pinia";
import type {WarningInfo} from "@/type/warn/WarningInfoListVo";
import useUserStore from "@/store/modules/user";
import {getToken} from "@/utils/auth";
import { getSwitchBySwitchType, updateSwitch} from "@/api/system/switch";
import {type Switch, SwitchTypeEnum} from "@/type/system/Switch";

const useWebSocket = defineStore(
    'webSocket',
    {
        state: (): { connection?: WebSocket; warnMessageList: WarningInfo[]; soundStatus?: Switch; } => ({
            connection: undefined,
            warnMessageList: [],
            soundStatus: undefined
        }),
        actions: {
            connect() {
                const userStore = useUserStore();

                if (this.connection || !userStore.token) {
                    console.log("拒绝链接ws")
                    return
                }
                const {host} = location
                // TODO   wss://${host}/warning/real
                const client = new WebSocket(`ws://${host}/warning/real`, [getToken()]);

                client.onmessage = ({data}) => {
                    let warnList = <WarningInfo[]>JSON.parse(data);
                    warnList = warnList.filter(item => userStore.hasProject(item.projectId))
                    if (warnList.length !== 0) {
                        this.warnMessageList = [...this.warnMessageList, ...warnList];
                    }
                }
                client.onopen = event => {
                    console.log("ws 连接成功")
                }
                this.connection = client;
            },
            disconnect() {
                this.connection?.close();
            },
            clearWarningList() {
                this.warnMessageList = [];
            },
            enableSound() {
                if (this.soundStatus) {
                    updateSwitch({id: this.soundStatus.id, status: 0} as Switch).then(res => {
                        this.soundStatus!.status = 0
                    })
                }
            },
            disableSound() {
                if (this.soundStatus) {
                    updateSwitch({id: this.soundStatus.id, status: 1} as Switch).then(res => {
                        this.soundStatus!.status = 1
                    })
                }
            }
        },
        getters: {
            isSound: async state => {
                const userStore = useUserStore();
                if (state.soundStatus === undefined) {
                    if (!userStore.token) {
                        return false
                    }
                    return await getSwitchBySwitchType(SwitchTypeEnum.notification_sound, {
                        nullDefaultCreate: true
                    }).then(res => {
                        state.soundStatus = res.data;
                    });
                }
                return state.soundStatus.status === 0;
            }
        }
    }
)

export default useWebSocket;